import { IAction, isType } from '@zaibot/fsa';

import { IConfig } from './IConfig';

import CONFIG from './actions/CONFIG';
import READY from './actions/READY';
import SESSION_RESTORED from './actions/SESSION_RESTORED';

export interface IState {
  ready: boolean;
  restoringSession: boolean;
  config: IConfig;
}
export default (state: IState = { ready: false, restoringSession: true, config: {} }, action: IAction) => {
  if (isType(action, SESSION_RESTORED)) {
    return { ...state, restoringSession: false };
  }
  if (isType(action, READY)) {
    return { ...state, ready: true };
  }
  if (isType(action, CONFIG)) {
    const config = action.payload;
    return { ...state, config };
  }
  return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/reducer.tsx